var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("設備狀態")]),_c('div',{staticClass:"outer-wrapper"},[_c('card'),_c('card'),_c('card'),_c('card'),_c('card'),_c('card'),_c('card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }